import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CommentEmptyCloud = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/message">
        <g id="message">
          <path
            id="Vector"
            d="M7.9987 15.2067C7.5387 15.2067 7.10536 14.9734 6.7987 14.5667L5.7987 13.2334C5.7787 13.2067 5.6987 13.1734 5.66536 13.1667H5.33203C2.55203 13.1667 0.832031 12.4134 0.832031 8.66671V5.33337C0.832031 2.38671 2.38536 0.833374 5.33203 0.833374H10.6654C13.612 0.833374 15.1654 2.38671 15.1654 5.33337V8.66671C15.1654 11.6134 13.612 13.1667 10.6654 13.1667H10.332C10.2787 13.1667 10.232 13.1934 10.1987 13.2334L9.1987 14.5667C8.89203 14.9734 8.4587 15.2067 7.9987 15.2067ZM5.33203 1.83337C2.94536 1.83337 1.83203 2.94671 1.83203 5.33337V8.66671C1.83203 11.68 2.86536 12.1667 5.33203 12.1667H5.66536C6.00536 12.1667 6.39203 12.36 6.5987 12.6334L7.5987 13.9667C7.83203 14.2734 8.16537 14.2734 8.3987 13.9667L9.3987 12.6334C9.6187 12.34 9.96536 12.1667 10.332 12.1667H10.6654C13.052 12.1667 14.1654 11.0534 14.1654 8.66671V5.33337C14.1654 2.94671 13.052 1.83337 10.6654 1.83337H5.33203Z"
          />
          <path
            id="Vector_2"
            d="M7.9987 7.99996C7.62536 7.99996 7.33203 7.69996 7.33203 7.33329C7.33203 6.96663 7.63203 6.66663 7.9987 6.66663C8.36536 6.66663 8.66536 6.96663 8.66536 7.33329C8.66536 7.69996 8.37203 7.99996 7.9987 7.99996Z"
          />
          <path
            id="Vector_3"
            d="M10.6667 7.99996C10.2933 7.99996 10 7.69996 10 7.33329C10 6.96663 10.3 6.66663 10.6667 6.66663C11.0333 6.66663 11.3333 6.96663 11.3333 7.33329C11.3333 7.69996 11.04 7.99996 10.6667 7.99996Z"
          />
          <path
            id="Vector_4"
            d="M5.33464 7.99996C4.9613 7.99996 4.66797 7.69996 4.66797 7.33329C4.66797 6.96663 4.96797 6.66663 5.33464 6.66663C5.7013 6.66663 6.0013 6.96663 6.0013 7.33329C6.0013 7.69996 5.70797 7.99996 5.33464 7.99996Z"
          />
        </g>
      </g>
    </svg>
  );
};

CommentEmptyCloud.displayName = 'CommentEmptyCloud';
